import gql from 'graphql-tag';

export default gql`
  query compareModuleState {
    compareModuleState @client {
      active
    }
  }
`;
